import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAppVersion } from "@/hooks/useAppVersion";

export function NewVersionBanner() {
  const { updateAvailable } = useAppVersion();

  if (!updateAvailable) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[100] flex flex-wrap items-center justify-between gap-3 border-b border-primary/30 bg-primary text-primary-foreground px-4 sm:px-6 py-2">
      <div className="flex items-center gap-2 text-sm font-medium">
        <RefreshCw className="h-4 w-4" />
        <span>Nova versão disponível</span>
      </div>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => window.location.reload()}
      >
        Atualizar agora
      </Button>
    </div>
  );
}

export default NewVersionBanner;
